import * as React from "react";

import axios from "axios";

import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";

import { HealthSurveillanceApi } from "../../../../healthSurveillance/healthSurveillanceApi";

interface Props {
    customerId: string;
    ohCaseId: string;
    complete: () => void;
}

export const CloseHSFFWCaseButton: React.FunctionComponent<Props> = (props: Props) => {
    const [closing, setClosing] = React.useState<boolean>(false);

    const onClick = async () => {
        setClosing(true);
        await new HealthSurveillanceApi(axios).dnaCloseCase(props.customerId, props.ohCaseId);
        setClosing(false);
        props.complete();
    };

    return (
        <ConfirmedButton
            className="warning"
            content="Close Case - DNA"
            promptText="You are about to close this case and notify the managers on the case. Do you wish to continue?"
            loading={closing}
            onClick={onClick}
            confirmText="Yes"
            cancelText="No"
        />
    );
};
